/* Naiak - Veja também (tp-nk-related-products-v1)
   Slider Swiper (snippet swiper-cdn). Como o <product-recommendations> do Dawn troca o HTML
   depois de buscar as recomendações, o slider é um custom element: cada render novo inicia sozinho. */
if (!customElements.get('tp-nk-related-slider')) {
  class TpNkRelatedSlider extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      const swiperEl = this.querySelector('[data-related-swiper]');
      if (!swiperEl || this.swiper || typeof window.Swiper === 'undefined') {
        this.classList.toggle('is-static', !this.swiper);
        return;
      }

      this.swiper = new window.Swiper(swiperEl, {
        slidesPerView: 2.15,
        spaceBetween: 16,
        centerInsufficientSlides: true,
        watchOverflow: true,
        grabCursor: true,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
        pagination: {
          el: this.querySelector('[data-related-pagination]'),
          clickable: true,
        },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 24 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
        },
      });

      this.classList.add('is-ready');
    }
  }

  customElements.define('tp-nk-related-slider', TpNkRelatedSlider);
}
